/**
 * @generated SignedSource<<4c9a005d6fec056bbdf1c2addf6eabd1>>
 * @relayHash 3205bc0ca50dc2399e40d591b039bea9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9b57f8d2f1162538766ba5b4202a4233cda83c185a033522d32ef13094dbd9a9

import type { ConcreteRequest, Query } from 'relay-runtime';
export type uiJiraLossAversionHasPaymentQuery$variables = {
  cloudId: string;
  productKey: string;
  shouldFetch: boolean;
};
export type uiJiraLossAversionHasPaymentQuery$data = {
  readonly tenantContexts?: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly subscription: {
          readonly accountDetails: {
            readonly invoiceGroup: {
              readonly invoiceable: boolean;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type uiJiraLossAversionHasPaymentQuery = {
  response: uiJiraLossAversionHasPaymentQuery$data;
  variables: uiJiraLossAversionHasPaymentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productKey"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "shouldFetch"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "productKey"
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "where",
    "value": {
      "AND": [
        {
          "inTrialOrPreDunning": true
        }
      ]
    }
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "invoiceable"
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = [
  (v6/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "uiJiraLossAversionHasPaymentQuery",
    "selections": [
      {
        "condition": "shouldFetch",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "args": (v2/*: any*/),
                "kind": "LinkedField",
                "name": "entitlementInfo",
                "plural": false,
                "selections": [
                  {
                    "args": (v3/*: any*/),
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "subscription",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "accountDetails",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "invoiceGroup",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "RequiredField",
                                    "field": (v4/*: any*/),
                                    "action": "THROW",
                                    "path": "tenantContexts.entitlementInfo.entitlement.subscription.accountDetails.invoiceGroup.invoiceable"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "storageKey": "entitlement(where:{\"AND\":[{\"inTrialOrPreDunning\":true}]})"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "uiJiraLossAversionHasPaymentQuery",
    "selections": [
      {
        "condition": "shouldFetch",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "args": (v2/*: any*/),
                "kind": "LinkedField",
                "name": "entitlementInfo",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "args": (v3/*: any*/),
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "subscription",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "accountDetails",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "invoiceGroup",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v4/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v7/*: any*/),
                                    "type": "CcpInvoiceGroup"
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v7/*: any*/),
                            "type": "CcpSubscription"
                          }
                        ]
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": "entitlement(where:{\"AND\":[{\"inTrialOrPreDunning\":true}]})"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "9b57f8d2f1162538766ba5b4202a4233cda83c185a033522d32ef13094dbd9a9",
    "metadata": {},
    "name": "uiJiraLossAversionHasPaymentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5d7f62e1285b435957547389de0d5f42";

export default node;
